<template>
	<modal ref="modal" style="z-index: 2000">
		<template #title>Sidebar Menu Details</template>
		<template #body>
			<div v-if="selectedMenu">
				<form @submit.prevent="update">
					<div class="form-floating mb-4">
						<input
							v-model="form.menu"
							type="text"
							class="form-control"
							:class="{ 'is-invalid': form.errors.menu }"
							id="menu"
							placeholder="Enter menu"
						/>
						<label class="form-label" for="menu">Menu</label>
						<div v-if="form.errors.menu" class="invalid-feedback">
							{{ form.errors.menu }}
						</div>
					</div>
					<div class="form-floating mb-4">
						<input
							v-model="form.icon"
							type="text"
							class="form-control"
							:class="{ 'is-invalid': form.errors.icon }"
							id="icon"
							placeholder="Enter icon"
						/>
						<label class="form-label" for="icon">Icon</label>
						<div v-if="form.errors.icon" class="invalid-feedback">
							{{ form.errors.icon }}
						</div>
					</div>
					<div class="form-floating mb-4">
						<input
							v-model="form.url"
							type="text"
							class="form-control"
							:class="{ 'is-invalid': form.errors.url }"
							id="url"
							placeholder="Enter url"
						/>
						<label class="form-label" for="url">URL</label>
						<div v-if="form.errors.url" class="invalid-feedback">
							{{ form.errors.url }}
						</div>
					</div>
					<div class="mb-4">
						<label class="form-label">Rank Visibility</label>
						<div class="form-group">
							<textarea
								v-model="form.rank_visibility"
								class="form-control"
								:class="{ 'is-invalid': form.errors.ç }"
								rows="5"
							/>
						</div>
						<div v-if="form.errors.menu" class="invalid-feedback">
							{{ form.errors.rank_visibility }}
						</div>
					</div>
					<button
						type="submit"
						class="btn btn-lg btn-alt-primary w-100 py-3 fw-semibold mb-4"
						data-toggle="click-ripple"
					>
						Save Changes
					</button>
				</form>
			</div>
		</template>
		<template #footer>
			<button @click="toggleModal" type="button" class="btn btn-alt-secondary">
				Close
			</button>
		</template>
	</modal>
</template>

<script>
import { ref, watch } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'

export default {
	props: {
		errors: Object,
		selectedMenu: Object,
	},
	setup(props) {
		const modal = ref(null)

		const toggleModal = () => {
			modal.value.toggleModal()
		}

		const form = useForm({
			menu: null,
			icon: null,
			url: null,
			rank_visibility: null,
			table: null,
			id: null,
			sidebar_menu_id: null,
		})

		watch(
			() => props.selectedMenu,
			(menu) => {
				form.menu = menu.menu
				form.icon = menu.icon
				form.url = menu.url
				form.rank_visibility = menu.rank_visibility
				form.table = menu.table
				form.id = menu.id
				form.sidebar_menu_id = menu.sidebar_menu_id
			}
		)

		const update = () => {
			form.post(route('admin.post.update-sidebar'), {
				preserveState: true,
				preserveScroll: true,
				only: ['errors', 'rows', 'flash'],
				onSuccess: () => toggleModal(),
			})
		}

		return {
			modal,
			toggleModal,
			form,
			update,
		}
	},
}
</script>
